export const GET_CHAT = "GET_CHAT";
export const SET_CHAT = "SET_CHAT";
export const GET_LOGO = "GET_LOGO";
export const SET_LOGO = "SET_LOGO";
export const GET_AYNC_MESS = "GET_AYNC_MESS";
export const SET_AYNC_MESS = "SET_AYNC_MESS";
export const GET_LOADING = "GET_LOADING";
export const SET_LOADING = "SET_LOADING";
export const GET_CONTACT = "GET_CONTACT";
export const SET_CONTACT = "SET_CONTACT";
